import JsonView from '@uiw/react-json-view';
import { nordTheme } from '@uiw/react-json-view/nord';

const ViewerStyle: React.CSSProperties = {
  ...nordTheme,
  backgroundColor: 'transparent',
  width: '100%',
  height: '100%',
};

export function JsonViewer({ data }: { data: object }) {
  return <JsonView value={data} style={ViewerStyle} />;
}
